import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,AlertController, DateTime} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,NUBE_AWS,URL_SERVICIOS_LOCALESFRONT } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { InformesProvider } from '../../providers/informes/informes'
import * as papa from 'papaparse'
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'informe-balance-negocio',
  templateUrl: 'informe-balance-negocio.html',
  providers: [ AuthService ,InAppBrowser]
})
export class InformeBalanceNegocioPage {
  datosPagina:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  fechaDesde:Date
  fechaHasta:Date
  imprimirNombreInforme:string=''

  parsedData:any
  parsedDataReal:any
  parseDataHeader:any

  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public servicioCompania:CompaniasProvider,private iab: InAppBrowser,
             public servicio:InformesProvider,
             public utils: UtilsProvider) {
              if(!MODO_DESCONECTADO){
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })
                this.storages.set('imprimirArchivoBalanceGeneral','')
               }else{

                 this.navCtrl.setRoot('PrincipalPage');
               }


  }


  ionViewDidLoad() {

  }
  public event = {
    default: "ddd MMM DD YYYY HH:mm:ss"
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  buscarBalance(){
    let fechaDesde = this.fechaDesde
    let fechaHasta = this.fechaHasta

    // '2018-07-28 00:00:00.000'

  this.storages.get('companiasId').then((val) => {

      if(fechaDesde!==undefined && fechaHasta!==undefined){
        let nombreInforme ='informeBalanceNegocio'
        let valoresInformes = `&companiasId=${val}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
        this.imprimirNombreInforme =`${nombreInforme}-${val}`
        if(NUBE_AWS) {
          let companiaId = val
          let fechadesde = fechaDesde
          let fechahasta = fechaHasta
          let nombre = nombreInforme
          this.servicio.buscarinformeVariosAWS(nombre,companiaId,fechadesde,fechahasta)
        } else {
          this.servicio.buscarinformeVarios(valoresInformes,nombreInforme,val)
        }
      } else{
        this.utils.mensajeMuestro('Debe seleccionar una fecha','Advertencia','warning')
      }
    })
  }

  descargarArchivo(){
      if(NUBE_AWS) {
        this.storages.get(this.imprimirNombreInforme).then((val) => {
          if(val){
            let data = JSON.parse(val)
            this.servicio.exportToExcel(data, 'balancegeneral')
            .then((result: any) => {
                console.log('result', result)
              }).catch((error)=> {
                console.log('error', error)
              })
          }else{
            this.utils.mensajeMuestro('Debe buscar el balance antes de poder descargar la información','Advertencia!','Advertencia')
            return false
          }
        })
      } else {
      if(this.imprimirNombreInforme!=''){
        this.iab.create(`${URL_SERVICIOS_LOCALESFRONT}/assets/${this.imprimirNombreInforme}.xlsx`,'_system')
      }else{
        this.mostrarMensajes('Debe buscar el balance antes de poder descargarla','Verifique')
      }
    }
  }

  imprimirRecibo(){

    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
        let data = JSON.parse(val)
        let Obj = this.armarImpresion(data)
        this.reemprimirRecibo(Obj)
      }else{
        this.mostrarMensajes('Debe buscar el balance antes de poder imprimirlo','Verifique')
      }
    })

  }

  visualizarInformacion(){

    this.storages.get(this.imprimirNombreInforme).then((val) => {
      if(val){
        let data = JSON.parse(val)
        this.generarGrid(data)
      }else{
        this.mostrarMensajes('Debe buscar el balance antes de poder visualizar la información','Verifique')
      }
    })

  }

  armarImpresion(data:any){
    let Obj = []
    for (let item of data) {
      let cadena = ''

      for (const key of Object.keys(item)) {

        cadena =`${item[key]}`
        let valores = `${key} :  ${cadena}`
        Obj.push({'reciboCaja':valores})
        cadena=''
        }
    }
    return Obj
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  reemprimirRecibo(mensaje) {
    let recibo = ''

  for (let index:any = 0; index < mensaje.length; index++) {
    recibo += mensaje[index]['reciboCaja'] + '\n'
  }

    this.servicio.imprimirRecibo(recibo).subscribe(
        res => {

        },
        err => {

                let alert = this.alertControllers.create({
                    title: '',
                    subTitle: recibo,
                    buttons: ['Cerrar']
                });
                alert.present();

            })
  }

  generarGrid(data:any){

    let Obj = []
    let cadena = ''
    let cabeza = ''
    for (let item of data) {

      for (const key of Object.keys(item)) {
        cadena+=`${item[key]}`
        cabeza+= `${key},`
        }
    }

    cabeza = cabeza.substr(cabeza.length - 1, 1) == ',' ? cabeza.substring(0, cabeza.length - 1) : cabeza;
    cabeza = cabeza + '\n'
    cadena = cadena + '\n'

    let realvalorgrid = ''
    realvalorgrid = `${cabeza}${cadena}`

    this.parsedData = papa.parse(realvalorgrid).data

    this.parseDataHeader =  this.parsedData[0]

    // this.parsedData.splice(0,1)

    this.parsedDataReal = this.parsedData

  }

  trackByFn(index:any,item:any){
    return index;
  }

}




// WEBPACK FOOTER //
// ./src/pages/informe-balance-negocio/informe-balance-negocio.ts